import { render, staticRenderFns } from "./unsubscribe-confirm.vue?vue&type=template&id=59fb95ad&"
import script from "./unsubscribe-confirm.vue?vue&type=script&lang=js&"
export * from "./unsubscribe-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports